<template>
  <v-col align="start">
    <v-col>
      <feather class="primary--text" type="x-circle" size="30" @click="reload()" style="cursor: pointer;"/>
    </v-col>
    <v-row>
      <v-col align="start">
        <h1 class="mb-4">Choose service type 
          <a style="font-size: 24px; font-weight: lighter;" @click="show = !show" class="primary--text"> - {{show ? 'Hide info' : 'Service type info?'}} </a>
        </h1>
      </v-col>
    </v-row>
    <v-row no-gutters class="btn-group">
      <v-col cols="5">
        <v-btn 
          class="primary btn"  
          height="45"
          style="border-radius: 30px;"
          v-on:click="goBack">Go back
        </v-btn>
      </v-col>
    </v-row>
    <br/>
    <v-container>
      <v-row class="mb-2" v-for="service in services" v-bind:key="service.key" justify="start" align="start">
        <v-card elevation="10" width="400" v-on:click="service.onClick" :class="service.isSelected ? 'grey darken-3 primary--text' : 'white black--text'">
          <v-container @click="scrollToTop()">
            <v-row justify="center">
              <v-col align="center">
                <p>{{ service.name }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-row>
      <v-row v-if="show">
        <v-col>
          <serviceType/>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import serviceType from '@/components/serviceType.vue';
export default {
  name: "ServiceType",
  components:{
    serviceType
  },
  props: {
    proceed: Function,
    vehicles: Array,
    goBack: Function
  },
  data() {
    return {
      yardSelected: false,
      selectedServiceType: {},
      services: [],
      canProceed: false,
      show: false
    }
  },
  watch: {
    selectedServiceType () {
      this.canProceed = true;
    }
  },
  methods: {
    scrollToTop(){
      setTimeout(() => {
        scroll(0, 0);
      }, 0)
    },
    reload(){
      this.$router.go();
    },
    selectService(service) {
      this.services.forEach( s =>  {
        s.isSelected = s.key === service;
        if (s.isSelected) {
          this.selectedServiceType = s;
          this.proceed(this.selectedServiceType);
        }
      });
    }
  },
  mounted() {
    scrollTo(0, 0);
    this.vehicles.forEach( (v) => {
      this.services.push( {...v, isSelected: false, image: require(`../../assets/4-yards.svg`), onClick: () => this.selectService(v.key) });
    });
  }
}
</script>

<style scoped>
.btn{
  width: 200px;
}
@media screen and (max-width: 550px){
  .btn-group{
    display: block;
  }
  .btn{
    margin-bottom: 0.5cm;
  }

}

</style>